import { HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useHelpTour } from "@/hooks/useHelpTour";

interface PageHelpButtonProps {
  tourKey: string;
}

export function PageHelpButton({ tourKey }: PageHelpButtonProps) {
  const { startTourInPlace, getTours } = useHelpTour();
  const tours = getTours();
  const tour = tours.find((t) => t.key === tourKey);

  if (!tour) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 text-muted-foreground hover:text-primary"
          onClick={() => startTourInPlace(tourKey)}
        >
          <HelpCircle className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Aide : {tour.title}</p>
      </TooltipContent>
    </Tooltip>
  );
}
